import { render, staticRenderFns } from "./aptitude.vue?vue&type=template&id=54c042dd&"
import script from "./aptitude.vue?vue&type=script&lang=js&"
export * from "./aptitude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports